import React from 'react';
import { Link } from 'react-router-dom';

const ForDeviceMakers = () => {
    return (
        <main className="min-h-screen bg-[#050914] text-white">

            <section className="pt-36 pb-28">
                <div className="max-w-[1200px] mx-auto px-8">

                    <div className="flex items-center gap-3 text-[11px] tracking-[0.28em] text-neutral-500 mb-7">
                        <span className="w-8 h-px bg-neutral-600" />
                        FOR DEVICE MAKERS
                    </div>

                    <h1 className="max-w-[950px] text-[48px] sm:text-[64px] lg:text-[76px] leading-[1] font-semibold tracking-[-0.045em]">
                        Give your next wearable
                        <br />
                        <span className="text-neutral-500">
              a new way to understand its user.
            </span>
                    </h1>

                    <p className="mt-8 max-w-[720px] text-[17px] leading-[1.7] text-neutral-400">
                        FroCort provides the intelligence layer. Device makers keep the
                        hardware, brand and customer relationship.
                    </p>

                    <div className="mt-10 flex flex-wrap gap-4">

                        <a
                            href="mailto:hello@frocort.com"
                            className="inline-flex items-center rounded-full bg-white text-neutral-950 px-6 py-3.5 text-[14px] font-medium hover:bg-neutral-200 transition-colors"
                        >
                            Talk to FroCort
                        </a>

                        <Link
                            to="/technology"
                            className="inline-flex items-center rounded-full border border-white/15 px-6 py-3.5 text-[14px] text-neutral-300 hover:bg-white/5 transition-colors"
                        >
                            Explore the technology
                        </Link>

                    </div>

                </div>
            </section>

            <section className="border-t border-white/10 py-28">
                <div className="max-w-[1200px] mx-auto px-8">

                    <div className="grid md:grid-cols-3 gap-px bg-white/10 rounded-[28px] overflow-hidden border border-white/10">

                        <div className="bg-[#050914] p-8 sm:p-10 min-h-[280px]">
                            <h2 className="text-[25px] font-medium">
                                Differentiate
                            </h2>

                            <p className="mt-5 text-[14px] leading-7 text-neutral-500">
                                Add cognitive intelligence as a new software capability without
                                building the entire intelligence stack internally.
                            </p>
                        </div>

                        <div className="bg-[#050914] p-8 sm:p-10 min-h-[280px]">
                            <h2 className="text-[25px] font-medium">
                                Personalize
                            </h2>

                            <p className="mt-5 text-[14px] leading-7 text-neutral-500">
                                Build experiences that respond to changes in the individual
                                user's state.
                            </p>
                        </div>

                        <div className="bg-[#050914] p-8 sm:p-10 min-h-[280px]">
                            <h2 className="text-[25px] font-medium">
                                Extend
                            </h2>

                            <p className="mt-5 text-[14px] leading-7 text-neutral-500">
                                Carry the intelligence layer across earbuds, headphones and
                                future wearable form factors.
                            </p>
                        </div>

                    </div>

                </div>
            </section>

        </main>
    );
};

export default ForDeviceMakers;